import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Domain-based route components
import VisaRoutes from './VisaRoutes';
import AuthRoutes from './AuthRoutes';

// Main layout and screens
import AuthLayout from '../components/AuthLayout';
import Dashboard from '../screens/Dashboard';
import Profile from '../screens/Profile';
import Subscription from '../screens/Subscription';
import NotFound from '../screens/NotFound';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import TermsOfService from '../screens/TermsOfService';
import PageTracker from '../components/PageTracker';

const AppRouter: React.FC = () => {
    const { currentUser } = useAuth();

    return (
        <BrowserRouter>
            <PageTracker />
            <Routes>
                {/* Public Legal Pages */}
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-use" element={<TermsOfService />} />
                
                {/* Auth Routes (public) */}
                <Route path="/auth/*" element={<AuthRoutes />} />

                {/* Protected Routes */}
                {currentUser ? (
                    <>
                        {/* Dashboard/Home */}
                        <Route
                            path="/"
                            element={
                                <AuthLayout>
                                    <Dashboard />
                                </AuthLayout>
                            }
                        />

                        {/* Domain-based Visa Routes */}
                        <Route path="/visa/*" element={<VisaRoutes />} />

                        {/* Profile Route */}
                        <Route
                            path="/profile"
                            element={
                                <AuthLayout>
                                    <Profile />
                                </AuthLayout>
                            }
                        />

                        {/* Subscription Route */}
                        <Route
                            path="/subscription"
                            element={<Subscription />}
                        />

                        {/* Redirect old routes to new structure */}
                        <Route path="/global-talent-visa" element={<Navigate to="/visa/global-talent-visa" replace />} />
                        <Route path="/tourist-visa" element={<Navigate to="/visa/tourist-visa" replace />} />
                    </>
                ) : (
                    /* Redirect unauthenticated users to login */
                    <Route path="*" element={<Navigate to="/auth/login" replace />} />
                )}

                {/* 404 Not Found */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter; 